import { css } from '@eti/styles';
import { useTranslation } from '@eti/providers';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const divStyles = (containerStyle, dotsStyle) => css`
  span {
    animation-duration: 1.2s;
    animation-fill-mode: both;
    animation-iteration-count: infinite;
    animation-name: blink;
    ${dotsStyle};
  }

  span:nth-child(2) {
    animation-delay: 0.2s;
  }

  span:nth-child(3) {
    animation-delay: 0.4s;
  }

  @keyframes blink {
    0% {
      opacity: 0.2;
    }
    20% {
      opacity: 1;
    }
    100% {
      opacity: 0.2;
    }
  }
  ${containerStyle};
`;
const LoadingDots = _ref => {
  let {
    ariaLabel,
    containerStyle,
    dataTestId = 'loadingDots',
    dotsStyle
  } = _ref;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/_jsxs("div", {
    "aria-label": ariaLabel || t('ScreenReader.Loading.AriaLabel.Text'),
    className: divStyles(containerStyle, dotsStyle),
    "data-testid": dataTestId,
    children: [/*#__PURE__*/_jsx("span", {
      children: "\u25CF"
    }), /*#__PURE__*/_jsx("span", {
      children: "\u25CF"
    }), /*#__PURE__*/_jsx("span", {
      children: "\u25CF"
    })]
  });
};
export default LoadingDots;